import { Box } from "@mui/material";
import Modal from "./Modal";

const ImageModal = ({ title, base64, open, onClose }) => {
  return (
    <Modal
      title={title}
      open={open}
      onClose={onClose}
    >
      <Box sx={{ padding: "10px" }}>
        <img
          src={base64}
          width="100%"
          height="auto"
        />
      </Box>
    </Modal>
  );
};

export default ImageModal;
